if (!customElements.get("tab-group")) {
  class TabGroup extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.triggers = Array.from(this.querySelectorAll("[data-tab]"));
      this.panels = Array.from(this.querySelectorAll("[role='tabpanel']"));

      this.triggers.forEach(trigger => {
        trigger.addEventListener("click", () => this.openTab(trigger));
      });

      this.querySelectorAll("[data-view-all-trigger]").forEach(button => {
        button.addEventListener("click", () => this.revealAll(button));
      });

      const defaultTrigger =
        this.querySelector("[data-tab][data-default-open]") ||
        this.triggers[0];

      if (defaultTrigger) {
        this.openTab(defaultTrigger);
      }

      this._initialized = true;
    }

    openTab(trigger) {
      const targetId = trigger.dataset.tab;
      const currentPanel = this.panels.find(p => !p.hasAttribute("hidden"));
      const nextPanel = this.panels.find(p => p.id === targetId);

      if (currentPanel === nextPanel) return;

      const swap = () => {
        this.triggers.forEach(t => {
          const isActive = t === trigger;
          t.classList.toggle("active", isActive);
          t.setAttribute("aria-selected", isActive ? "true" : "false");
        });

        this.panels.forEach(panel => {
          const isActive = panel.id === targetId;
          panel.classList.toggle("is-hidden", !isActive);
          if (isActive) {
            panel.removeAttribute("hidden");
          } else {
            panel.setAttribute("hidden", "");
          }
        });
      };

      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (!this._initialized || reduceMotion || typeof document.startViewTransition !== "function") {
        swap();
        this._initialized = true;
        return;
      }

      // Scope the transition to just the panels area so the rest of the page
      // doesn't get captured/animated.
      const panelsContainer = this.querySelector(".faq-tabs__panels") || this;
      const transitionName = `tab-group-${this._uid || (this._uid = Math.random().toString(36).slice(2, 9))}`;
      panelsContainer.style.viewTransitionName = transitionName;

      const transition = document.startViewTransition(swap);
      transition.finished.finally(() => {
        panelsContainer.style.viewTransitionName = "";
      });
    }

    revealAll(button) {
      const panel = button.closest("[role='tabpanel']");
      if (!panel) return;

      panel
        .querySelectorAll(".faq-tabs__item--hidden")
        .forEach(item => item.classList.remove("faq-tabs__item--hidden"));

      const wrapper = button.closest(".faq-tabs__view-all") || button;
      wrapper.hidden = true;
    }
  }

  customElements.define("tab-group", TabGroup);
}
